module.exports = __webpack_public_path__ + "img/ic_pickup_group_order_bill_backgroud.1f222aa2.png";